export const PROJECT_STATUS = {
  IN_PROGRESS: 'in_progress',
  SENT_TO_REVIEW: 'sent_to_review',
  APPROVED: 'approved',
  AWAITING: 'awaiting',
  ONBOARDING: 'onboarding',
  ARCHIVED: 'archived',
};

export const PROJECT_PLAN = {
  CONSULTANCY: 'consultancy',
};

export const PROJECT_ROOM_TYPE = {
  ROOM_STYLING: 'room_styling',
  DESIGN_FIX: 'design_fix',
};

export const CATEGORY_RELEASE_STATUS = {
  NONE: 'none',
  REQUESTED: 'requested',
  APPROVED: 'approved',
};

export const ADDITIONAL_HOURS_STATUS = {
  NONE: 'none',
  REQUESTED: 'requested',
  APPROVED: 'approved',
};



// WEBPACK FOOTER //
// ./app/javascript/common/constants/project.js